import React from 'react';
import './ExpeditionTrackLegend.css';

const ExpeditionTrackLegend = ({ visible = false }) => {
  if (!visible) return null;

  return (
    <div className="expedition-track-legend" aria-label="Expedition track legend">
      <div className="expedition-track-legend-title">Expedition track</div>
      <div className="expedition-track-legend-item">
        <span className="expedition-track-legend-dot" aria-hidden />
        <span>Sampling site</span>
      </div>
      <div className="expedition-track-legend-item">
        <span className="expedition-track-legend-line" aria-hidden />
        <span>Route</span>
      </div>
    </div>
  );
};

export default ExpeditionTrackLegend;
